

















































































































































































































































import { Component, Vue } from "vue-property-decorator";
import DoKoTitle from "./components/common/DoKoTitle.vue";
import DoKoPig from "./components/common/DoKoPig.vue";
import DoKoFullscreenBtn from "./components/menu/DoKoFullscreenBtn.vue";
import DoKoCardBlanko from "./components/card/background/DoKoCardBlanko.vue";
import DoKoCardBackPattern from "./components/card/background/DoKoCardBackPattern.vue";

import { Action, Getter } from "vuex-class";
import { api } from "./store";
import { api as userApi } from "./store/modules/user";
import { ROUTE_NAMES } from "./router/routenames";

@Component({
  components: {
    DoKoTitle,
    DoKoPig,
    DoKoFullscreenBtn,
    DoKoCardBlanko,
    DoKoCardBackPattern,
  },
})
export default class App extends Vue {
  loading = true;
  version = [
    process.env.VUE_APP_CI_COMMIT_TAG,
    process.env.VUE_APP_BUILD_TIMESTAMP,
  ].join(" - "); //;

  @Getter(api.getters.isUserAuthenticated)
  isUserAuthenticated!: boolean;

  @Action(api.actions.init)
  initStore!: () => Promise<void>;

  @Action(userApi.actions.signout, { namespace: userApi.namespace })
  signout!: () => Promise<void>;

  created(): void {
    this.initStore().then(() => {
      this.loading = false;
    });
  }
  sendSignout(): void {
    if (this.$route.name === ROUTE_NAMES.LOBBY) {
      this.signout().then(() => {
        this.$router.push({
          name: ROUTE_NAMES.HOME,
        });
      });
    } else {
      this.$router.push({
        name: ROUTE_NAMES.HOME,
      });
    }
  }
}
